import * as actions from '../constants/actions'
import { createReducer } from '../utils/redux'

export default createReducer(3006, {

    [actions.CHANGE_SRID]: (state, action) => action.srid

})



// WEBPACK FOOTER //
// ./src/reducers/srid.js